import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useLogo } from 'app/frontend/base/hooks/useLogo'
import { Check, TriangleAlert, X } from 'lucide-react'

type Props = {
  member: wowaudit.TeamMembership
  usersById?: Record<string, wowaudit.UserReference>
  userIdsWithDuplicateMains: number[]
  size?: 'small' | 'medium'
} & React.HTMLAttributes<HTMLDivElement>

const UserBnetConnection = ({
  member,
  usersById,
  userIdsWithDuplicateMains,
  className,
  size = 'medium',
}: Props) => {
  const { Logo } = useLogo()

  const user =
    member.characterReference.userId && usersById
      ? usersById[member.characterReference.userId.toString()]
      : null

  const hasDuplicateMains = member.characterReference.userId
    ? userIdsWithDuplicateMains.includes(member.characterReference.userId)
    : false

  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge
          className={`flex items-center ${
            size === 'small' ? 'gap-1 px-1' : 'gap-2'
          } transition-opacity duration-300 ${
            usersById ? 'opacity-100' : 'opacity-0'
          }  ${className}`}
          variant='outline'
        >
          <Logo className={'h-4 w-4 opacity-70'} />
          {user ? (
            hasDuplicateMains ? (
              <TriangleAlert
                size={size === 'small' ? 13 : 16}
                className='text-warning-foreground'
              />
            ) : (
              <Check
                size={size === 'small' ? 13 : 16}
                className='text-success-foreground'
              />
            )
          ) : (
            <X
              size={size === 'small' ? 13 : 16}
              className='text-destructive-foreground'
            />
          )}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        {user ? (
          <div className='text-center'>
            <div className='opacity-70 text-xs mb-0.5'>Battletag</div>
            <div>{user.obfuscatedBattletag ?? 'Hidden user'}</div>
            {hasDuplicateMains ? (
              <div className='text-xs text-warning-foreground mt-1'>
                This user has multiple non-alt characters on the roster
              </div>
            ) : null}
          </div>
        ) : (
          <span className='italic text-muted-foreground'>
            Not a wowaudit user
          </span>
        )}
      </TooltipContent>
    </Tooltip>
  )
}

export default UserBnetConnection
